module.exports = __webpack_public_path__ + "static/media/ponewin.c15caef2.png";